export default __webpack_public_path__ + "static/media/equipment1.30278564.jpg";